export default __webpack_public_path__ + "static/media/Arch_AWS-CloudFormation_64.3e314036.svg";